import api from './api';

/**
 * Service for role-related API calls
 */

/**
 * Fetch all roles (admin/manager only)
 * @returns {Promise<Array>} Array of role data
 */
export const fetchAllRoles = async () => {
  try {
    const response = await api.get('/roles');
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};

/**
 * Fetch a single role by ID (admin/manager only)
 * @param {string} roleId - The ID of the role to fetch
 * @returns {Promise<Object>} Role data
 */
export const fetchRoleById = async (roleId) => {
  try {
    const response = await api.get(`/roles/${roleId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching role ${roleId}:`, error);
    throw error;
  }
};

/**
 * Create a new role (admin only)
 * @param {Object} roleData - Data for the new role
 * @param {string} roleData.name - Name of the role
 * @param {string} roleData.description - Description of the role
 * @param {Array<string>} roleData.permissions - Array of permission strings
 * @returns {Promise<Object>} Created role data
 */
export const createRole = async (roleData) => {
  try {
    const response = await api.post('/roles', roleData);
    return response.data;
  } catch (error) {
    console.error('Error creating role:', error);
    throw error;
  }
};

/**
 * Update a role (admin only)
 * @param {string} roleId - The ID of the role to update
 * @param {Object} updateData - Data to update the role with
 * @param {string} updateData.name - Name of the role
 * @param {string} updateData.description - Description of the role
 * @param {Array<string>} updateData.permissions - Array of permission strings
 * @returns {Promise<Object>} Updated role data
 */
export const updateRole = async (roleId, updateData) => {
  try {
    const response = await api.patch(`/roles/${roleId}`, updateData);
    return response.data;
  } catch (error) {
    console.error(`Error updating role ${roleId}:`, error);
    throw error;
  }
};

/**
 * Delete a role (admin only)
 * @param {string} roleId - The ID of the role to delete
 * @returns {Promise<void>}
 */
export const deleteRole = async (roleId) => {
  try {
    await api.delete(`/roles/${roleId}`);
  } catch (error) {
    console.error(`Error deleting role ${roleId}:`, error);
    throw error;
  }
};
